import { render, staticRenderFns } from "./IconArrowLeft.vue?vue&type=template&id=f9836b5c"
import script from "./IconArrowLeft.vue?vue&type=script&lang=ts"
export * from "./IconArrowLeft.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports